import React from "react";
import SummaryWrapper from "./summarydetailtop.style";
import { withTranslation } from "react-i18next";
import { useMediaQuery } from "../../../../_shared/Media/media";
import bill_paid from "../../../../assets/images/icons/bill_paid.svg";
import btn_download from "../../../../assets/images/icons/btn_download.svg";

const SummaryInfo = ({ i18n, policy, travel, url }) => {
  let isPageWide = useMediaQuery("(min-width: 577px)");
  let isMob = useMediaQuery("(max-width: 576px)");

  return (
    <SummaryWrapper>
      <div
        className={
          "Summary-wrapper pt-5 " + (i18n.language === "ar" ? "ar" : "")
        }
      >
        <div className="container">
          {isPageWide && (
            <div className="row item">
              <div className="col-9 top-message">
                {travel ? (
                  <>
                    <p> {i18n.t("TRAVEL_SUCCESS", { policy: policy })}</p>
                    <span>
                      {" "}
                      {i18n.t("ready-to-use")},
                      <br /> {i18n.t("ready-to-use2")}
                    </span>
                  </>
                ) : (
                  <>
                    <p>Your policy #{policy} has been renewed successfully!</p>
                    <span>
                      Thank you for choosing Tawuniya, Your policy is ready to
                      use.
                    </span>
                  </>
                )}

                {url && (
                  <div className="row">
                    <div className="col-3">
                      <a href={url} download={true}>
                        <button className="btn box-button d-inline-flex justify-content-center align-items-center">
                          <img src={btn_download} alt="" />
                          {i18n.t("DOWNLOAD_POLICY")}
                        </button>
                      </a>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-3 top-message-alt">
                <img src={bill_paid} alt="bill paid" />
              </div>
            </div>
          )}
          {isMob && (
            <div className="row item">
              <div className="col-row top-message">
                <img src={bill_paid} alt="bill paid" />
              </div>

              <div className="col-row top-message">
                {travel ? (
                  <>
                    <p> {i18n.t("TRAVEL_SUCCESS", { policy: policy })}</p>
                    <span>
                      {i18n.t("ready-to-use")},
                      <br /> {i18n.t("ready-to-use2")}
                    </span>
                  </>
                ) : (
                  <>
                    <p>
                      Your policy <br></br>has been renewed successfully!
                    </p>
                    <span>
                      Thank you for choosing Tawuniya,<br></br> Your policy is
                      ready to use.
                    </span>
                  </>
                )}

                {url && (
                  <div className="row">
                    <div className="col-12">
                      <a href={url} download={true}>
                        <button className="btn box-button d-inline-flex justify-content-center align-items-center">
                          <img src={btn_download} alt="" />
                          {i18n.t("DOWNLOAD_POLICY")}
                        </button>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </SummaryWrapper>
  );
};
export default withTranslation()(SummaryInfo);
